module.exports = __webpack_public_path__ + "static/media/badge_ptrnA.018dc510.png";